<template>
	<div class="df1" v-loading.fullscreen.lock="loading">
		<el-form ref="form" :model="form" :rules="rules"   
		              label-position="top">
					 
			<el-form-item label="公司/厂牌名称" prop="name" > 
				<el-input v-model="form.name" placeholder="" ></el-input>
			</el-form-item> 
			<el-form-item label="邮箱" prop="eMail">
				<el-input v-model="form.eMail" placeholder="" ></el-input>
			</el-form-item> 
			<el-form-item label="涉及侵权平台" prop="infringedPlatform">
				<el-input v-model="form.infringedPlatform" placeholder="" ></el-input>
			</el-form-item> 
			<el-form-item label="请确认您的版权性质" prop="identify">
				<el-select v-model="form.identify" placeholder=""  filterable   :style="{width: '100%'}" :popper-append-to-body="false" >
					<el-option v-for="(item, index) in identifyOption" :key="index" :label="item.label"
							   :value="item.value" ></el-option>
				 </el-select>
			</el-form-item> 
			<div class="divForm">
				<div class="divDFrom">
					<div class="blueClass"></div>
					投诉歌曲信息
				</div>
				<el-form-item label="歌曲名称"  prop="complaintTrackTitle">
					<span class="labelSpan" style="left: 95px;"> 在列举多个项目或元素时，使用逗号进行分隔</span>
					<el-input v-model="form.complaintTrackTitle" type="textarea" 
							resize="none"    :autosize="{ minRows: 3,maxRows: 3 }" ></el-input>
				</el-form-item>
				<el-form-item label="侵权歌曲收听链接"  prop="complaintTrackLink">
					<span class="labelSpan" style="left: 135px;"> 在列举多个项目或元素时，使用逗号进行分隔</span>
					<el-input v-model="form.complaintTrackLink" type="textarea" 
							resize="none"    :autosize="{ minRows: 4,maxRows: 4 }" ></el-input>
				</el-form-item>
			</div>
			
			
			<div class="divForm" :style="{'paddingBottom': divLength}">
				<div class="divDFrom">
					<div class="blueClass"></div>
					原作品信息
				</div>
				
				<el-form-item label="歌曲名称"  prop="originalTrackTitle">
					<span class="labelSpan" style="left: 95px;"> 在列举多个项目或元素时，使用逗号进行分隔</span>
					<el-input v-model="form.originalTrackTitle" type="textarea" 
							resize="none"    :autosize="{ minRows: 3,maxRows:3 }" ></el-input>
				</el-form-item>
				<el-form-item label="原版歌曲收听链接"  prop="originalTrackLink">
					<span class="labelSpan" style="left: 95px;"> 在列举多个项目或元素时，使用逗号进行分隔</span>
					
				  <el-input v-model="form.originalTrackLink" type="textarea" 
							resize="none"    :autosize="{ minRows: 4,maxRows: 4 }" ></el-input>
				</el-form-item>
				
				<div style="height: 100px;
							position: absolute;
							top: 1420px;
							font-size: 8px;">
					<el-upload
					  ref="upload"
					  class="upload-demo"
					  accept=".pdf"
					  action="https://cms.ewway.com/ewway-api/common/uploadWeb"
					  :on-remove="handleRemove"
					  :on-success="handleAvatarSuccess"
					  :on-exceed="handleExceed"
					  :on-error="handleError"
					  :before-upload="handleBefore"
						:multiple=true
					  :limit="10"
					  >
					  <el-button size="small" type="primary">上传文件</el-button>
					  <div slot="tip" class="el-upload__tip">支持格式：pdf  ; 每个文件最大不超过20M</div>
					</el-upload>
				</div>
				
					
				<el-form-item label="权利证明文件"  prop="fileInfo" style="margin-bottom: 0px;">
					<el-input v-model="form.fileInfo" style="display: none;" ></el-input>
				</el-form-item>
			</div>
			
			<el-form-item label="情况描述"  prop="description" >
			  <el-input v-model="form.description" type="textarea" 
						resize="none"    :autosize="{ minRows: 4 }" ></el-input>
			</el-form-item>
			
			
			<el-form-item label="" >
			  <el-checkbox v-model="check1" ></el-checkbox>
			  <span class="checkBoxClass" >我声明以上所提供的陈述和材料都是真实、有效、完整且合法的</span><br>
			  <el-checkbox v-model="check2" ></el-checkbox>
			  <span class="checkBoxClass" >我理解并同意，EWway有权将我提交的相关材料转通知给涉及的被投诉方，并在法律目的所需的时间内保留。</span><br>
			  <el-checkbox v-model="check3"  style="margin-right: 30px;"></el-checkbox>
			  <span class="checkBoxClass" >我明白，滥用此程序可能会对我未来提出发行请求的能力造成限制</span><br>
			</el-form-item>
			
			<div v-if="required" style="width: 100%;margin-bottom: 20px; margin-top: -18px;">
				<img style="width: 14px;float: left;" src="@/assets/images/svg/web-required.svg" />必选
			</div>
			
			
			<el-button type="primary" @click="add">提交</el-button>
					
		</el-form>
		
	</div>
	
</template>

<script>
	
import axios from 'axios';

export default {
	name : "Form2",
	data() {
		//艺术家
		const checkFile = (rule, value, callback) => {
		  console.info(value);
		  if(this.form.fileInfo && this.form.fileInfo !=""){
			  return callback()
		  }else{
			  return callback(new Error("不能为空"))
		  }
		};
			
		return {
			identifyOption:[
				{"label":"拥有本作品的录音权利","value":"拥有本作品的录音权利"},
				{"label":"拥有本作品的著作权（例：词、曲）","value":"拥有本作品的著作权（例：词、曲）"},
				{"label":"我拥有艺术品的版权（例：封面图）","value":"我拥有艺术品的版权（例：封面图）"},
				{"label":"其他","value":"其他"},
				],
			form:{
				fileList:[],
			},
			divLength: "120px",
			rules:{
				name: [
				  { required: true, message: "不能为空", trigger: "blur" }
				],
				eMail: [
				  { required: true, message: "不能为空", trigger: "blur" }
				],
				infringedPlatform: [
				  { required: true, message: "不能为空", trigger: "blur" }
				],
				identify: [
				  { required: true, message: "不能为空", trigger: ["blur","change"]}
				],
				complaintTrackTitle: [
				  { required: true, message: "不能为空", trigger: "blur" }
				],
				complaintTrackLink: [
				  { required: true, message: "不能为空", trigger: "blur" }
				],
				originalTrackTitle: [
				  { required: true, message: "不能为空", trigger: "blur" }
				],
				originalTrackLink: [
				  { required: true, message: "不能为空", trigger: "blur" }
				],
				fileInfo: [
				  { required: true, validator: checkFile, message: "不能为空", trigger: ["blur","change"]}
				],
			},
			
			fileList:[],
			check1:false,
			check2:false,
			check3:false,
			
			loading:false,
			
			required:false,
		}
	},
	watch:{
		fileList(val){
			console.info(val);
		}
	},
	methods:{
		
		
	handleBefore(file){
			  for (var i = 0; i < this.fileList.length; i++) {
				if(this.fileList[i].fileName == file.name){
					this.$message({
							type: 'error',
							message: "上传文件名字重复",
							customClass :'customClass',
							duration:3000,
					});
					return false;
				}
			  }
			  let temp = {
				  fileName : file.name
			  }
			  this.fileList.push(temp);
			  return true;
	},
		//上传成功
      handleAvatarSuccess(res, file) {
		if(res.code===200){
			this.$message({
					type: 'success',
					message: "success",
					customClass :'customClass',
					duration:3000,
			}); 
			let temp = {
				fileUrl : res.fileName,
				fileName : res.originalFilename,
			}
			this.form.fileList.push(temp);
			if(this.form.fileList.length<=0){
				this.form.fileInfo = null;
			}else{
				this.form.fileInfo = JSON.stringify(this.form.fileList);
			}
			this.divLength = ( 120 + (this.form.fileList.length - 1)*29.9375 ) +"px"
			this.$nextTick(function(){
				this.$refs["form"].validateField('fileInfo')
			})
		}else{
			this.$message({
					type: 'error',
					message: "error",
					customClass :'customClass',
					duration:3000,
			}); 
		    // this.$refs.upload.clearFiles();
		}
        
		this.$forceUpdate();
      },
		
	  handleRemove(file, fileList) {
		if (file && file.status==="success") {
			 // console.info(this.form.fileList)
			 for (var i = 0; i < this.form.fileList.length; i++) {
			 	if(this.form.fileList[i].fileName === file.name){
			 		this.form.fileList.splice(i,1);
			 		break;
			 	}
			 }
			 console.info(this.form.fileList);
			 if(this.form.fileList.length<=0){
			 	this.form.fileInfo = null;
			 }else{
			 	this.form.fileInfo = JSON.stringify(this.form.fileList);
			 }
			 this.divLength = ( 120 + (this.form.fileList.length - 1)*29.9375 ) +"px"
			 this.$forceUpdate();
			 
			 this.$nextTick(function(){
			 	this.$refs["form"].validateField('fileInfo')
			 }) 
		}
	  },
	  handleError(){
		  this.form.fileUrl = null
		  this.$refs.upload.clearFiles();
		  this.$forceUpdate();
	  },
	  handlePreview(file) {
		console.log(file);
	  },
	  handleExceed(files, fileList) {
		this.$message({
				type: 'warning',
				message: "只能选择10个文件",
				customClass :'customClass',
				duration:3000,
		}); 
	  },
	  
	  add(){
		  if( ! this.check1 || ! this.check2 || ! this.check3){
			  this.required = true
			  return ;
		  }
		  this.required = false
		  
	  	this.$refs["form"].validate(valid => {
	  		if (valid) {
				console.info(this.form);
				this.loading = true
	  			axios.post('https://cms.ewway.com/ewway-api/feedback/infringement', this.form)
	  				.then(response => {
						this.loading = false
	  				  // 处理返回的数据
	  				  if(response.data.code===200){
	  					 this.$message({
	  					 							type: 'success',
	  					 							message: "提交成功！我们将尽快处理并回复您的消息，衷心感谢您对我们的关注与支持！",
	  					 							customClass :'customClass',
	  					 							duration:2000,
	  					 }); 
						 this.$refs['form'].resetFields();
						 this.$refs.upload.clearFiles();
						 this.divLength = ( 120 + (this.form.fileList.length - 1)*29.9375 ) +"px"
	  				  }else{
	  					  this.$message({
	  					  							type: 'error',
	  					  							message: "提交失败！",
	  					  							customClass :'customClass',
	  					  							duration:2000,
	  					  });
	  				  }
	  				  
	  				})
	  				.catch(error => {
	  				  console.error(error);
						this.loading = false
	  				  // 错误处理逻辑
	  				  this.$message({
	  							type: 'error',
	  							message: "网络错误",
	  							customClass :'customClass',
	  							duration:2000,
	  				  });
	  				});
	  		}
	  			
	  	});
	  }
	  
	}
}
</script>
<style scoped>
	.df1{
		width:80%;
		margin-left:10%;
		text-align: left;
	}
	.labelSpan{
		position: absolute;
		top: -50px;
		font-size: 12px;
		color: #A5A3BE;
	}
	.divForm{
		padding: 20px 15px 20px 8px ;
		background-color: #F2F2F2;
		margin-top: 15px;
	}
	.divDFrom{
		font-size: 16px;;
		
	}
	.blueClass{
		height: 8px;
		width: 8px;
		background-color: #4A7FDB;
		float: left;
		margin: 5px;
		border-radius:4px
	}
	.customClass{
		font-size:12px;
	}
	.checkBoxClass{
		font-size: 12px;
	}
</style>